import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ICompanyNotificationSchema } from '../../../../graphql/type/companyNotification';
import useRoutes from '../../../components/_hook/useRoutes';
import Moment from '../../../components/Moment';

interface IProps {
  companyNotification: ICompanyNotificationSchema;
}

export default function CompanyNotificationIncomingNewOrderAskForQuoteMenuItem(
  props: IProps
) {
  const { companyNotification } = props;
  const { path } = useRoutes();
  const { t } = useTranslation();

  return (
    <MenuItem
      component={Link}
      to={path('procurement.incoming.enquiry', {
        companyID: companyNotification.companyId,
        docID: companyNotification.data.orderAskForQuoteId,
      })}
    >
      <ListItemText
        primary={t('incoming_new_enquiry')}
        secondary={
          <>
            <div>
              {t('you_have_a_new_enquiry_from__userName__', {
                userName: companyNotification.data.buyerUserName,
              })}
              {companyNotification.data.buyerCompanyName
                ? ` - ${companyNotification.data.buyerCompanyName}`
                : ''}
            </div>
            {companyNotification.created &&
              companyNotification.created.time && (
                <Moment time={companyNotification.created.time} />
              )}
          </>
        }
        primaryTypographyProps={{
          variant: 'subtitle2',
          style: {
            whiteSpace: 'pre-wrap',
          },
        }}
        secondaryTypographyProps={{
          variant: 'subtitle2',
          style: {
            whiteSpace: 'pre-wrap',
          },
        }}
      />
    </MenuItem>
  );
}
